export enum AuthenticationRoutes {
    LOGIN = '/v1/auth/login',
    REFRESH = '/v1/auth/token/refresh',
    LOGOUT = '/v1/auth/logout',
}
